<template>
    <input v-model="keyValue" @input="formatValue" type="text">
</template>

<script>
export default {
    props: {
        value: {
            type: String
        },
        index: {
            type: Number
        }
    },
    data(){
        return {
            keyValue: this.value
        }
    },
    methods: {
        formatValue : function(event){
            //SCREAMING_SNAKE_CASE formatting
            let eventValue = ''
            if(this.keyValue){
                eventValue = this.keyValue.toUpperCase().replace('-', '_').replace(' ','_').replace(/[^_\dA-Z]/, '')
            }
            this.keyValue = eventValue
            this.$emit('formatted', eventValue, this.index)
        },
    },
}
</script>

<style>

</style>
